import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SpsTooltipComponent } from "../components/index";

@NgModule({
    imports: [CommonModule],
    declarations: [SpsTooltipComponent],
    exports: [SpsTooltipComponent]
})
export class SpsTooltipModule {}
